import { createContext, Dispatch } from 'react';
import type { ReportsAction, ReportState } from './types';

/**
 * Context type for the reports domain
 *
 * Contains state and dispatch function for state management.
 *
 * @example
 * const context: ReportsContextType = {
 *   state: reportsInitialState,
 *   dispatch: () => {},
 * };
 */
export type ReportsContextType = {
  state: ReportState;
  dispatch: Dispatch<ReportsAction>;
};

/**
 * Context for the reports domain
 */
export const ReportsContext = createContext<ReportsContextType | null>(null);
